import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ipWhitelistService from '../../services/ipWhitelistService';

const initialState = {
  ipList: [],
  currentIp: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  },
  loading: false,
  error: null
};

export const fetchIpWhitelist = createAsyncThunk(
  'ipWhitelist/fetchAll',
  async (params, thunkAPI) => {
    try {
      const response = await ipWhitelistService.getIpWhitelist(params);
      return response;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to fetch IP whitelist';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createIpWhitelist = createAsyncThunk(
  'ipWhitelist/create',
  async (data, thunkAPI) => {
    try {
      const response = await ipWhitelistService.createIpWhitelist(data);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to add IP';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIpWhitelist = createAsyncThunk(
  'ipWhitelist/update',
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await ipWhitelistService.updateIpWhitelist(id, data);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to update IP';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteIpWhitelist = createAsyncThunk(
  'ipWhitelist/delete',
  async (id, thunkAPI) => {
    try {
      await ipWhitelistService.deleteIpWhitelist(id);
      return id;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to delete IP';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const ipWhitelistSlice = createSlice({
  name: 'ipWhitelist',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIpWhitelist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIpWhitelist.fulfilled, (state, action) => {
        state.loading = false;
        state.ipList = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchIpWhitelist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createIpWhitelist.pending, (state) => {
        state.loading = true;
      })
      .addCase(createIpWhitelist.fulfilled, (state, action) => {
        state.loading = false;
        state.ipList.unshift(action.payload);
      })
      .addCase(createIpWhitelist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateIpWhitelist.fulfilled, (state, action) => {
        const index = state.ipList.findIndex(ip => ip.id === action.payload.id);
        if (index !== -1) {
          state.ipList[index] = action.payload;
        }
      })
      .addCase(deleteIpWhitelist.fulfilled, (state, action) => {
        state.ipList = state.ipList.filter(ip => ip.id !== action.payload);
      });
  }
});

export const { clearError } = ipWhitelistSlice.actions;
export default ipWhitelistSlice.reducer;
